import { Link } from "react-router-dom"
import { Compass } from "lucide-react"
import { Button } from "@/components/ui/button"
import { EmptyState } from "@/components/shared/empty-state"

export function NotFound() {
  return (
    <EmptyState
      icon={Compass}
      title="Page not found"
      description="The page you are looking for doesn't exist or has been moved."
      className="min-h-[60vh]"
      action={
        <Button asChild size="sm">
          <Link to="/dashboard">Back to dashboard</Link>
        </Button>
      }
    />
  )
}
